import { createActionTypes } from '../../../util/createLifeomicActionTypes';

export default createActionTypes([
  'GROUPS_PAGE_TOGGLE_DIALOGUE',
  'GROUPS_PAGE_TOGGLE_INVITE_MEMBER_DIALOGUE',
  'GROUPS_PAGE_SET_GROUP_TO_EDIT',
]);
